import { Label } from '@radix-ui/react-dropdown-menu'
import * as React from 'react'

import { cn } from '~/styled'

import { Text } from '../text/Text'

type DropdownMenuLabelProps = React.ComponentProps<typeof Label>

export const DropdownMenuLabel = ({
  className,
  ...props
}: DropdownMenuLabelProps) => (
  <Text
    as={Label}
    size="sm"
    className={cn('px-3', 'py-2', 'text-text-subtle', className)}
    {...props}
  />
)

DropdownMenuLabel.displayName = 'DropdownMenuLabel'
